module.exports = __webpack_public_path__ + "img/logo_idf.48456bcc.svg";